import apiClient from '../../api';
import { baseAPIUrl } from '../constants';

export const getVms = async () => {
    const { data } = await apiClient({
        url: `${baseAPIUrl}/vms`,
    });
    return data;
};

export const getVmConfigs = async () => {
    const { data } = await apiClient({
        url: `${baseAPIUrl}/vmconfigs`,
    });
    return data;
};

export const purgeVm = async ({ name }) => {
    const { data } = await apiClient({
        url: `${baseAPIUrl}/vmconfigs/${name}`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return data;
};

export const deleteVm = async ({ name }) => {
    const { data } = await apiClient({
        url: `${baseAPIUrl}/vms/${name}`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return data;
};

export const deployVm = async ({ name, node }) => {
    const { data } = await apiClient({
        url: `${baseAPIUrl}/vms`,
        method: 'POST',
        timeout: 0,
        data: {
            vmConfig: name,
            node,
        },
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return data;
};

export const createVm = async ({ name, image, cpu, memory }) => {
    const { data } = await apiClient({
        url: `${baseAPIUrl}/vmconfigs`,
        method: 'POST',
        data: {
            name,
            image,
            cpu,
            memory: parseInt(memory, 10),
        },
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return data;
};

export const saveVmImage = async ({ name, newName }) => {
    const { data } = await apiClient({
        timeout: 0,
        url: `${baseAPIUrl}/vms/${name}/save`,
        method: 'POST',
        data: {
            imageName: newName,
        },
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return data;
};

export const commitVmImage = async ({ name }) => {
    const { data } = await apiClient({
        timeout: 0,
        url: `${baseAPIUrl}/vms/${name}/commit`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return data;
};
